import React from 'react';

export default function About() {
  return (
    <div className="fade-in" style={{ maxWidth: 700, margin: '0 auto', padding: '48px 20px' }}>
      <h1 style={{ fontSize: 32, marginBottom: 16 }}>About eBike Dubai</h1>
      <p style={{ color: 'var(--text-2)', lineHeight: 1.8, marginBottom: 24 }}>
        eBikeDubai.ae is Dubai's dedicated marketplace for electric bikes and scooters. We connect buyers and sellers of Surron, Talaria, Kugoo, and other leading e-bike brands across the UAE.
      </p>
      <p style={{ color: 'var(--text-2)', lineHeight: 1.8, marginBottom: 24 }}>
        Whether you're looking to buy your first electric dirt bike, upgrade to a newer model, or sell your current ride — we make the process simple, transparent, and WhatsApp-first.
      </p>

      <h2 style={{ fontSize: 20, marginBottom: 16, marginTop: 32 }}>Why Choose Us</h2>
      <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
        {[
          ['⚡ Verified Listings', 'Every bike is reviewed before being listed'],
          ['💬 WhatsApp-First', 'No complicated checkout — chat directly with us'],
          ['🏍️ Test Rides', 'Schedule a test ride before committing'],
          ['💰 Fair Pricing', 'Market-based pricing with no hidden fees'],
          ['🛡️ Trusted', 'Building Dubai\'s most trusted e-bike community'],
        ].map(([t, d]) => (
          <div key={t} style={{ background: 'var(--dark-2)', padding: 20, borderRadius: 12, border: '1px solid var(--dark-4)' }}>
            <h3 style={{ fontSize: 15, marginBottom: 4, color: 'var(--volt)' }}>{t}</h3>
            <p style={{ color: 'var(--text-2)', fontSize: 14 }}>{d}</p>
          </div>
        ))}
      </div>
    </div>
  );
}
